var render = function render(){
  var _vm$wiseAccountDetail, _vm$payOption, _vm$me, _vm$me2, _vm$me3, _vm$me4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.me ? _c('Spinner', {
    attrs: {
      "size": 16,
      "color": "blue"
    }
  }) : _vm._e(), _vm.me ? _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "col-span-1 2xl:col-span-2 flex gap-6"
  }, [_c('div', {
    staticClass: "flex flex-col gap-5"
  }, [_c('h2', {
    staticClass: "font-bold mr-2 pb-4 border-b"
  }, [_vm._v("Payment Information")]), !_vm.wiseAccountDetails ? _c('Spinner', {
    attrs: {
      "size": 16,
      "color": "blue"
    }
  }) : _vm._e(), (_vm$wiseAccountDetail = _vm.wiseAccountDetails) !== null && _vm$wiseAccountDetail !== void 0 && _vm$wiseAccountDetail.recipientAccount || _vm.me.billingContact.paymentMethod == 'Bitcoin' ? _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_vm.me && _vm.me.billingContact.paymentMethod == 'Bitcoin' ? _c('YInput', {
    attrs: {
      "label": "Crytocurrency",
      "readonly": true,
      "value": this.walletType
    }
  }) : _vm._e(), _vm.me && _vm.me.billingContact.paymentMethod == 'Bitcoin' ? _c('YInput', {
    attrs: {
      "label": "Wallet Address",
      "readonly": true,
      "value": this.walletId
    }
  }) : _vm._e(), _vm.me && _vm.me.billingContact.paymentMethod == 'Wise' ? _c('YInput', {
    attrs: {
      "label": "Currency",
      "readonly": true
    },
    model: {
      value: _vm.currency.code,
      callback: function ($$v) {
        _vm.$set(_vm.currency, "code", $$v);
      },
      expression: "currency.code"
    }
  }) : _vm._e(), _vm.me && _vm.currency.code && _vm.me.billingContact.paymentMethod == 'Wise' ? _c('YInput', {
    attrs: {
      "label": "Pay Option",
      "readonly": true
    },
    model: {
      value: _vm.formattedTitle,
      callback: function ($$v) {
        _vm.formattedTitle = $$v;
      },
      expression: "formattedTitle"
    }
  }) : _vm._e(), _vm.me && (_vm$payOption = _vm.payOption) !== null && _vm$payOption !== void 0 && _vm$payOption.title && _vm.me.billingContact.paymentMethod == 'Wise' ? _c('YInput', {
    attrs: {
      "label": "Account Holder",
      "readonly": true
    },
    model: {
      value: this.filters.name.fullName,
      callback: function ($$v) {
        _vm.$set(this.filters.name, "fullName", $$v);
      },
      expression: "this.filters.name.fullName"
    }
  }) : _vm._e(), _vm._l(this.filters.aDetails, function (value, key, index) {
    var _vm$payOption2;
    return _c('div', {
      key: index
    }, [_vm.me && (_vm$payOption2 = _vm.payOption) !== null && _vm$payOption2 !== void 0 && _vm$payOption2.title && _vm.me.billingContact.paymentMethod == 'Wise' ? _c('YInput', {
      attrs: {
        "label": _vm.formatWiseLabels(key),
        "readonly": true
      },
      model: {
        value: _vm.filters.aDetails[key],
        callback: function ($$v) {
          _vm.$set(_vm.filters.aDetails, key, $$v);
        },
        expression: "filters.aDetails[key]"
      }
    }) : _vm._e()], 1);
  })], 2) : _vm._e(), this.qrCodeUrl && ((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : _vm$me.is2faEnabled) == false && this.validQR == false ? _c('div', {
    staticClass: "flex flex-col gap-4"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.qrCodeUrl,
      "alt": "QR Code for 2FA"
    }
  })]), _c('p', {
    staticClass: "text-xs"
  }, [_vm._v(" To edit payment details, please scan the QR code with your preferred authenticator app (Google Authenticator recommended) to set up 2FA. ")]), _vm._m(0), _c('YInput', {
    staticClass: "w-64",
    attrs: {
      "label": "Enter 6-digit code"
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('YButton', {
    staticClass: "w-40",
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.verifyCode();
      }
    }
  }, [_vm._v(" Verify ")])], 1) : _vm._e(), this.validQR == false && ((_vm$me2 = _vm.me) === null || _vm$me2 === void 0 ? void 0 : _vm$me2.is2faEnabled) == true && ((_vm$me3 = _vm.me) === null || _vm$me3 === void 0 ? void 0 : _vm$me3.is2faValid) != true ? _c('div', {
    staticClass: "grid grid-cols-1 gap-4"
  }, [_c('h2', [_vm._v(" To edit payment details please authenticate using 2fa authenticator code: ")]), _c('YInput', {
    attrs: {
      "label": "Enter 6-digit code"
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('YButton', {
    staticClass: "w-40",
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.verifyCode();
      }
    }
  }, [_vm._v(" Verify ")])], 1) : _vm._e(), _vm.wiseAccountDetails && _vm.validQR == true || ((_vm$me4 = _vm.me) === null || _vm$me4 === void 0 ? void 0 : _vm$me4.is2faValid) == true ? _c('div', [_c('YButton', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreatePaymentInfoModal();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.me.billingContact.paymentMethod ? 'Change ' : 'Add') + " Payment Details ")])], 1) : _vm._e(), !_vm.userPaymentHistory ? _c('Spinner', {
    attrs: {
      "size": 16,
      "color": "blue"
    }
  }) : _vm._e(), _c('h2', {
    staticClass: "font-bold mr-2 pb-4 border-b"
  }, [_vm._v("Payment History")]), _c('YTable', {
    staticClass: "table-striped table-hover overflow-hidden",
    attrs: {
      "scroll-x": false,
      "data": _vm.userPaymentHistory.data || [],
      "isLoading": !_vm.userPaymentHistory
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function (props) {
        return [_c('td', [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.created)) + " ")]), _c('td', [_vm._v(" " + _vm._s(Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(props.rowData.targetValue)) + " ")]), props.rowData.paymentType == 'bitcoin' ? _c('td', [_vm._v(" Crypto Wallet (BTC) ")]) : _c('td', [_vm._v(" Bank Transfer (via Wise) ")]), _c('td', [_vm._v(" " + _vm._s(props.rowData.status.replace(/_/g, ' ').replace(/\b\w/g, function (char) {
          return char.toUpperCase();
        })) + " ")]), _c('td', [props.rowData.paymentType == 'bitcoin' ? _c('YButton', {
          staticClass: "w-full",
          attrs: {
            "color": "gray",
            "is-loading": _vm.receiptLoading
          },
          on: {
            "click": function ($event) {
              return _vm.openUrl(props.rowData.transactionUrl);
            }
          }
        }, [_vm._v(" Open Transaction Url ")]) : _c('YButton', {
          staticClass: "w-full",
          attrs: {
            "color": "gray",
            "is-loading": _vm.receiptLoading
          },
          on: {
            "click": function ($event) {
              return _vm.downloadTransferReceipt(props.rowData.transferId);
            }
          }
        }, [_vm._v(" Download Receipt ")])], 1)];
      }
    }, {
      key: "after",
      fn: function () {
        return [_vm.userPaymentHistory.paginatorInfo ? _c('YPagination', {
          key: _vm.totalPages,
          attrs: {
            "data": _vm.userPaymentHistory.paginatorInfo
          },
          on: {
            "load-page": _vm.loadPage,
            "next-page": _vm.nextPage,
            "previous-page": _vm.previousPage,
            "per-page": _vm.perPageSelection
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 1784556940)
  }, [_c('template', {
    slot: "header-row"
  }, [_c('th', {
    staticStyle: {
      "min-width": "9rem",
      "max-width": "9rem"
    }
  }, [_vm._v("Date")]), _c('th', {
    staticStyle: {
      "width": "5rem"
    }
  }, [_vm._v("Amount (USD)")]), _c('th', [_vm._v("Payment Type")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Reciept")])])], 2)], 1)])]) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "text-xs -mt-2"
  }, [_vm._v(" ⚠️ "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v("Important:")]), _vm._v(" Make sure you are 100% certain which device and account you use for authentication. Once 2FA is configured, it cannot be modified or transferred. If this account is accessed by multiple users, ensure that all users have access to the same authenticator, or you may be permanently locked out. ")]);

}]

export { render, staticRenderFns }